import styled from '@emotion/styled';
import { createPortal } from 'react-dom';
import { spacing } from '@/lib/design-tokens';
import { useToastStore } from '@/stores/toast-store';
import { Toast } from './Toast';

const ToastList = styled.div`
  position: fixed;
  top: ${spacing[300]};
  right: ${spacing[300]};
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: ${spacing[200]};
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

function ToastProvider() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  return createPortal(
    <ToastList aria-live="polite" role="region" aria-label="通知">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </ToastList>,
    document.body,
  );
}

export { ToastProvider };
